import { database, sendRequest } from "./firebase";

export async function updateChatStatus(chat, chatId) {
  try {
    await database.ref(`chats/${chatId}/`).update(chat);
    return 'success'
  } catch (err) {
    console.error(err);
    return Promise.reject(err)
  }
}

export async function loadUserChatInfo(uid, messages, chatId) {
  try {
    let result = await database.ref(`users/${uid}/`).once('value')
    result = result.val();

    let chatObject = {
      companionData: result,
      chat: messages,
      chatId: chatId
    };

    if (result) return chatObject
  }
  catch (err) {
    console.error(err);
    return Promise.reject(err)
  }
}

export async function sendChatMessage(chat, chatId) {
  try {
    await database.ref(`chats/${chatId}/`).update(chat);
    return 'success'
  }
  catch (err) {
    console.error(err);
    return Promise.reject(err)
  }
}

export async function getChat(chatId) {
  let entry = await database.ref(`chats/${chatId}`).once('value');

  if (!entry.val()) return null;
  return entry.val()
}

export async function postChat(chatId) {
  return await database.ref(`chats/${chatId}`).set([{
    date: "",
    user: null,
    message: "zero mess"
  }]);
}

export async function getAllChatsOfUserListener(callbackAllChatsOfUserListener) {
  database.ref(`chats`).on('value', function (dataSnapshot) {
    dataSnapshot && callbackAllChatsOfUserListener(dataSnapshot.val());
  });
}

export async function getAllChatsOfUser(currentUserId) {
  let entry = await database.ref(`chats`).once('value');
  let allChats = entry.val();

  let currentUserChats = {};

  for( let key in allChats) {
    let isHaveUserId = key.indexOf(currentUserId) + 1;

    if (isHaveUserId) {
      let chat = allChats[key];
      currentUserChats[key] = chat
    }
  }

  return currentUserChats
}

export async function getStatisticChats() {
  return sendRequest('getStatisticChats', {})
}

export async function getStatisticUsers() {
  return sendRequest('getStatisticUsers', {})
}



// WEBPACK FOOTER //
// ./src/services/firebase/chats.js